import { render, staticRenderFns } from "./sonTeamEmployees.vue?vue&type=template&id=2550e7c6&scoped=true&"
import script from "./sonTeamEmployees.vue?vue&type=script&lang=js&"
export * from "./sonTeamEmployees.vue?vue&type=script&lang=js&"
import style0 from "./sonTeamEmployees.vue?vue&type=style&index=0&id=2550e7c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550e7c6",
  null
  
)

export default component.exports